<template>
  <div v-if="!mobileMode" class="desktop-nav">
    <v-app-bar
      class="home app-bar pa-0"
      color="transparent"
      flat
      app
      height="auto"
      elevate-on-scroll
      v-if="$route.name === 'Home'"
    >
      <transition name="fade">
        <v-progress-linear
          v-if="appLoading"
          fixed
          class="nav-progress"
          color="primary"
          indeterminate
          height="4"
          ></v-progress-linear>
      </transition>
      <v-container>
        <v-row>
          <v-col class="d-flex justify-space-between align-center pa-0">
            <v-img
              alt="Logo"
              class="shrink mr-8"
              contain
              :src="require('../../assets/logo.png')"
              transition="scale-transition"
              width="300"
              height="72"
            />
            <v-spacer></v-spacer>
            <div class="nav">
              <v-bottom-navigation width="100%" class="flex-shrink-1 flex-grow-0" active-class="active" :value="0" height="48">
                <v-btn class="item" v-for="item in groups" :key="item.id" text @click="onClick(item)">{{item.text}}</v-btn>
              </v-bottom-navigation>
            </div>
            <v-spacer></v-spacer>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-app-bar
      class="app-bar pa-0"
      fixed
      color="#FFF"
      flat
      height="auto"
      elevate-on-scroll
      prominent
      v-else
    >
      <v-container class="px-4">
        <v-row>
          <v-col class="d-flex align-center col-12 pa-0">
            <div class="logo-wrapper d-flex align-center flex-shrink-0" @click="redirect">
              <v-img
                alt="Logo"
                class="shrink mr-6"
                contain
                :src="require('../../assets/logo.png')"
                transition="scale-transition"
                width="300"
                height="72"
              />
            </div>
            <v-spacer></v-spacer>
            <div class="nav">
              <v-tabs :value="current" width="100%" height="48" class="flex-shrink-1 flex-grow-0">
                <v-tab class="item" v-for="(item, index) in groups" :key="item.id" :value="index" @click="onClick(item)">
                  {{item.text}}
                </v-tab>
              </v-tabs>
            </div>
            <v-btn class="account" v-if="isLogin">
              <v-icon>mdi-account</v-icon>
              <ul>
                <li><a href="https://fuzhouctyc.com/workbench/sso/login.jsp">进入工作台</a></li>
                <li><a href="/yuncai/caslogout">注销</a></li>
              </ul>
            </v-btn>
            <v-spacer></v-spacer>
            <!-- <v-btn class="btn-register-login" elevation="0">注册 / 登录</v-btn> -->
          </v-col>
        </v-row>
      </v-container>
      <transition name="fade">
        <v-progress-linear
          v-if="appLoading"
          absolute
          class="nav-progress"
          color="primary"
          indeterminate
          height="4"
          ></v-progress-linear>
      </transition>
    </v-app-bar>
  </div>
  <div v-else class="mobile-nav">
    <v-app-bar
      class="app-bar pa-0"
      app
      color="#FFF"
      flat
      height="auto"
      elevate-on-scroll
      prominent
    >
      <div class="inner-wrapper col-12 pa-0">
        <v-container class="px-4 ">
          <v-row>
            <v-col class="d-flex justify-space-between align-center col-12 pa-0">
              <div class="logo-wrapper d-flex align-center flex-shrink-0" @click="redirect">
                <v-img
                  alt="Logo"
                  class="mr-6"
                  contain
                  :src="require('../../assets/logo.png')"
                  transition="scale-transition"
                  width="250"
                  height="60"
                />
              </div>
              <v-spacer></v-spacer>
              <!-- <div class="current">{{current}}</div> -->
              <v-btn class="account" v-if="isLogin">
                <v-icon>mdi-account</v-icon>
                <ul>
                  <li><a href="https://fuzhouctyc.com/workbench/sso/login.jsp">进入工作台</a></li>
                  <li><a href="/yuncai/caslogout">注销</a></li>
                </ul>
              </v-btn>
              <v-app-bar-nav-icon class="nav-button-icon" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            </v-col>
          </v-row>
        </v-container>
        <!-- <div class="register-login">
          <v-container class="py-2 px-4">
            <v-row class="ma-0">
              <v-col class="col-12 pa-0 d-flex align-center justify-end">
                <div class="text-wrapper">采购人、供应商、专家，<v-btn text class="btn-register-login pa-0">请注册/登录</v-btn></div>
              </v-col>
            </v-row>
          </v-container>
        </div> -->
      </div>
      <transition name="fade">
        <v-progress-linear
          v-if="appLoading"
          absolute
          class="nav-progress"
          color="primary"
          indeterminate
          height="4"
          ></v-progress-linear>
      </transition>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      right
    >
      <v-list
        shaped
      >
        <v-list-item
          v-for="item in groups"
          :key="item.id"
          ripple
          @click="onClick(item)"
        >
          <!-- <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon> -->
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Nav',
  data: () => {
    return {
      loaded: false,
      drawer: false,
      current: 0,
      groups: [{
        id: 0,
        name: 'Home',
        path: '/',
        text: '首页'
      }, {
        id: 1,
        name: 'Engineering',
        path: '/engineering',
        text: '招标大厅'
      }, {
        id: 2,
        name: 'Logistics',
        path: '/logistics',
        text: '项目公告'
      }, {
        id: 3,
        name: 'PolicyStatute',
        path: '/policy-statute',
        text: '政策法规'
      },
      {
        id: 5,
        name: 'News',
        path: '/news',
        text: '新闻资讯'
      }, {
        id: 6,
        name: 'Shop',
        path: 'https://yc.yonyoucloud.com/mall-cli-portal/static/pages/index/index.html#index/index',
        text: '网上超市'
      }, {
        id: 7,
        name: 'Manua',
        path: '/manual',
        text: '业务指南'
      }, {
        id: 8,
        name: 'Contact',
        path: '/contact',
        text: '关于我们'
      }]
    }
  },
  computed: {
    ...mapState({
      appLoading: state => state.app.appLoading
    }),
    mobileMode () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
        case 'md':
          return true
        case 'lg':
        case 'xl':
          return false
      }
      return false
    },
    isLogin () {
      if (window.document.cookie.indexOf('tenantid') >= 0) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    $route () {
      this.current = this.getCurrent()
    }
  },
  methods: {
    getCurrent () {
      for (let i = 0; i < this.groups.length; i++) {
        const item = this.groups[i]
        const path = item.path.split('/')[1]
        if (path && this.$route.path.split('/')[1].indexOf(path) >= 0) {
          return i
        }
      }
      return this.current
    },
    onClick (item) {
      if (this.$route.name !== item.name) {
        if (item.path.indexOf('https') !== -1) {
          window.open(item.path, '_blank')
        } else {
          this.$router.push(item.path)
        }
      }
    },
    redirect () {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-nav {
  position: relative;
  z-index: 1000;
  .nav-progress {
    bottom: 0;
  }
  .app-bar {
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
    .register-login {
      background-color: #e3e3e3;
      }
    .btn-register-login {
      float: right;
      height: auto;
      min-width: auto;
      font-size: inherit;
      color: $main-color;
      vertical-align: baseline;
    }
  }
}
.logo-wrapper {
  cursor: pointer;
}
.desktop-nav {
  position: relative;
  z-index: 1000;
  .v-bottom-navigation {
    box-shadow: none;
  }
  .app-bar {
    &:not(.home) {
      box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
      .v-tab {
        padding-left: 0;
        padding-right: 0;
      }
    }
    &.home {
      top: 32px;
      transition: all .25 ease;
      .nav-progress {
        top: -32px;
      }
      .btn-register-login {
        font-size: inherit;
        border-color: $main-color;
        color: $main-color;
        height: 48px;
      }
      .nav {
        .v-bottom-navigation {
          background-color: $main-color;
        }
        .v-btn.item {
          height: 100%;
          font-size: 18px;
          font-weight: bold;
          color: rgba(255, 255, 255, 0.7) !important;
          padding: 10px 10px;
          &.active {
            color: #FFF !important;
          }
          &:not(:last-child){
            &::after {
              content: '';
              position: absolute;
              right: -0.5px;
              width: 1px;
              height: 18px;
              background-color: #FFF;
            }
          }
        }
      }
    }
    &.v-app-bar--is-scrolled {
      top: 0;
      background-color: #FFF !important;
      box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
    }
  }
  .app-bar:not(.home) {
    .nav-progress {
      bottom: 0;
    }
    .nav {
      .v-btn.item {
        height: 100%;
        font-size: 16px;
        font-weight: bold;
        // color: rgba(0, 0, 0, 0.3) !important;
        padding: 15px 20px;
      }
    }
    .btn-register-login {
      color: $main-color;
    }
  }
}
.account {
  position: relative;
  background-color: transparent!important;
  box-shadow: none;
  ul {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    list-style: none;
    padding-left: 0;
    top: calc(100% + 10px);
    background-color: #fff;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    li {
      padding: 10px 16px;
      a {
        text-decoration: none;
        color: inherit;
      }
      &:hover {
        background-color: #e8e8e8
      }
    }
    &:before {
      position: absolute;
      top: 0;
      left: 50%;
      width: 0;
      height: 0;
      border: 8px solid transparent;
      border-bottom-color: #e8e8e8;
      border-top: 0;
      border-left: 0;
      margin-left: -4px;
      margin-top: -8px;
      content: '';
    }
  }
  &:hover {
    ul {
      visibility: visible;
      opacity: 1;
    }
  }
}
</style>
